import { DEAL_INFO_TYPES } from './deal-info-types';
import { DEFAULT_CURRENCY, CURRENCIES } from './currencies';
export const getDefaultVideoDealInfo = function (currency) {
  var _CURRENCIES$currency, _CURRENCIES$currency2;
  if (currency === void 0) {
    currency = DEFAULT_CURRENCY;
  }
  return [{
    type: DEAL_INFO_TYPES.RENT,
    enabled: false,
    price: (_CURRENCIES$currency = CURRENCIES[currency]) == null ? void 0 : _CURRENCIES$currency.rent.default,
    period: 72
  }, {
    type: DEAL_INFO_TYPES.SALE,
    enabled: false,
    price: (_CURRENCIES$currency2 = CURRENCIES[currency]) == null ? void 0 : _CURRENCIES$currency2.sale.default
  }];
};
export const FREE_VIDEO_DEAL_INFO = [{
  type: DEAL_INFO_TYPES.RENT,
  price: 0.01,
  enabled: false,
  period: 24
}, {
  type: DEAL_INFO_TYPES.SALE,
  price: 0.01,
  enabled: false,
  period: 0
}];
//# sourceMappingURL=video-deal-info.js.map